export default {
  namespaced: true,
  state: {
    picListSelected: [],
    isShowPoster: false,
    shareBtn: {
      btnList: []
    },
    platform: 'wx_session',
    wx_link: {
      url: 'xxx',
      title: 'hello world',
      description: 'hello description',
      thumbImageBase64: ''
    },
    wx_image: {
      imageBase64: ''
    }
  },
  mutations: {
    setPicListSelected(state, picListSelected) {
      state.picListSelected = picListSelected;
    },
    setIsShowPoster(state, isShowPoster) {
      state.isShowPoster = isShowPoster;
    },
    setShareBtn(state, btnList) {
      state.shareBtn.btnList = btnList;
    }
  },
  getters: {
    picNumSeclected(state) {
      return state.picListSelected.length - 1;
    }
  }
};
